module.exports = __webpack_public_path__ + "img/_dashboard.1b81cc4b.svg";